<ng-template [ngIf]="config">

  <!--POLYLINE-->
  <ng-template [ngIf]="config.mapType && config.mapType == 'POLYLINE' && coordinates && coordinates.length > 0">
    
    <agm-map [fitBounds]="true" 
      [style.height]="config.height ? config.height : '0'" 
      [style.width]="config.width ? config.width : '0'" >
    
      <agm-marker 
        *ngFor="let coordinate of coordinates"
        [agmFitBounds]="true"
        [latitude]="coordinate.lat ? coordinate.lat : 0" 
        [longitude]="coordinate.lng ? coordinate.lng : 0"
        [label]="coordinate.label ? coordinate.label : ''">
      </agm-marker>
    
      <agm-polyline>
        <agm-polyline-point
          *ngFor="let coordinate of coordinates" 
          [latitude]="coordinate.lat ? coordinate.lat : 0" 
          [longitude]="coordinate.lng ? coordinate.lng : 0">
        </agm-polyline-point>
      </agm-polyline>

    </agm-map>

  </ng-template>
  <!--/POLYLINE-->

  <!--MARKERS-->
  <ng-template [ngIf]="config.mapType && config.mapType == 'MARKERS' && coordinates && coordinates.length > 0">
    
    <agm-map [fitBounds]="true" 
      [style.height]="config.height ? config.height : '0'" 
      [style.width]="config.width ? config.width : '0'" >
    
      <agm-marker 
        *ngFor="let coordinate of coordinates"
        [agmFitBounds]="true"
        [latitude]="coordinate.lat ? coordinate.lat : 0" 
        [longitude]="coordinate.lng ? coordinate.lng : 0"
        [label]="coordinate.label ? coordinate.label : ''">
      </agm-marker>

    </agm-map>

  </ng-template>
  <!--/MARKERS-->

</ng-template>
